import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ApplicationResponse,
  StateTrackedData,
} from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
export type ProjectStore = {
  minimal: StateTrackedData<any[]>;
};
export const closeProjectStatus = createAsyncThunk<any, {projectId: any,projectType: any}>(
  "closeProject/closeProjectStatus",
  async ({ projectId, projectType }) => {
    const url = `${AppConstants.api}/project/close?projectId=${projectId}&projectType=${projectType}`;
    const response = await api.put<ApplicationResponse<any>>(url);
    return;
  }
);


const closeProjectStatusSlice = createSlice({
  name: "projectStatus",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
  } as ProjectStore,
  reducers: {},
  extraReducers: (builder) => {
    builder
     
  },
});

export default closeProjectStatusSlice.reducer;
